function getIntercom() {
    // @ts-ignore
    return window.Intercom || null;
}
export function showIntercomMessenger() {
    if (getIntercom()) {
        getIntercom()('show');
    }
}
export function hideIntercomMessenger() {
    if (getIntercom()) {
        getIntercom()('hide');
    }
}
export function updateIntercomMessenger(options) {
    if (getIntercom()) {
        getIntercom()('update', options);
    }
}
export function shutdownIntercomMessenger() {
    if (getIntercom()) {
        getIntercom()('shutdown');
    }
}
//# sourceMappingURL=intercomControl.js.map